
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M17.3 6.29998C16.91 5.90998 16.28 5.90998 15.89 6.29998L10.25 11.94L11.66 13.35L17.3 7.69998C17.68 7.31998 17.68 6.67998 17.3 6.29998ZM21.54 6.28998L11.66 16.17L8.18 12.7C7.79 12.31 7.16 12.31 6.77 12.7C6.38 13.09 6.38 13.72 6.77 14.11L10.95 18.29C11.34 18.68 11.97 18.68 12.36 18.29L22.95 7.70998C23.34 7.31998 23.34 6.68998 22.95 6.29998H22.94C22.56 5.89998 21.93 5.89998 21.54 6.28998ZM1.12 14.12L5.3 18.3C5.69 18.69 6.32 18.69 6.71 18.3L7.41 17.6L2.53 12.7C2.14 12.31 1.51 12.31 1.12 12.7C0.729999 13.09 0.729999 13.73 1.12 14.12Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-done-all`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconDoneAll

    ```js
    <b-new-b-icon-done-all />
    ```
</docs>


